import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RatesFilterStateService } from '../../state/rates-filter-state.service';
import { POPOVER_CONTEXT, PickerComponent } from './picker.types';
import { pickerRegistry } from './picker-registry';

/**
 * RILA/VA filter block — ProtectionTypeSegmentedPickerComponent (2026-06-05).
 *
 * Three-button segmented control: Buffer Only / Floor Only / Both.
 * Single-select with click-to-clear (clicking the active button clears
 * the selection back to null).
 *
 * RILA/VA-only — hidden on FA/IA via DIM_TAB_APPLICABILITY.
 */
@Component({
  selector: 'app-protection-type-segmented-picker',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './protection-type-segmented-picker.component.html',
  styleUrl: './protection-type-segmented-picker.component.scss',
})
export class ProtectionTypeSegmentedPickerComponent implements PickerComponent {
  protected readonly ctx = inject(POPOVER_CONTEXT);
  protected readonly filterState = inject(RatesFilterStateService);

  protected readonly options: ReadonlyArray<string> = ['Buffer Only', 'Floor Only', 'Both'];

  protected readonly active = computed<string | null>(() => {
    this.filterState.version();
    return this.filterState.activeSlot().selectedProtectionType;
  });

  onClick(opt: string): void {
    const current = this.active();
    const next = current === opt ? null : opt;
    this.filterState.setSlotField('selectedProtectionType', next);
    this.filterState.requestApplyFilters();
  }
}

pickerRegistry['protection-type'] = {
  component: ProtectionTypeSegmentedPickerComponent,
  label: 'Protection',
  field: 'selectedProtectionType',
  group: 'Strategy',
};
